<template>
	<div class="border-top">
		<SOFilterTitle :title="'Status Transaksi'" :diterapkan="diterapkan" :id="id"/>
		<div class="p-l-24 p-r-24 p-d-24" v-show="false" :id="id">
			<SOInputCheckbox
				:checkboxes="statusTransaksiSnapclean"
				:checked="filterItem.statusTransaksiSnapclean"
				@selected="selected"
			/>
		</div>
	</div>
</template>

<script>
import {mapGetters} from "vuex"

import SOFilterTitle from "@/so-components/global/filter/base/SOFilterTitle";
import SOInputCheckbox from "@/so-components/global/input/SOInputCheckbox";

export default {
	name: "SOFilterStatusTransaksiSnapclean",
	components: {
		SOFilterTitle,
		SOInputCheckbox,
	},
	props: {
		id: String,
	},
	computed: {
		...mapGetters("filterGlobalModule", {
			filterItem: "getFilterItem"
		})
	},
	data() {
		return {
			statusTransaksiSnapclean: {
				name: "status-transaksi",
				data: [
					{
						id: "fstat-transaksi-snap-1",
						value: "order",
						title: "Belum Jalan",
						checked: false,
						titleBold: false,
					},
					{
						id: "fstat-transaksi-snap-2",
						value: "pengerjaan",
						title: "Sedang Berjalan",
						checked: false,
						titleBold: false,
					},
					{
						id: "fstat-transaksi-snap-3",
						value: "selesai",
						title: "Selesai",
						checked: false,
						titleBold: false,
					},
				]
			},
			diterapkan: false,
		}
	},
	mounted() {
		this.diterapkan = this.filterItem.statusTransaksiSnapclean.length > 0
	},
	methods: {
		selected(val) {
			let temp = this.filterItem
			temp.statusTransaksiSnapclean = val
			this.$store.commit("filterGlobalModule/setFilterItem", temp)
			this.diterapkan = this.filterItem.statusTransaksiSnapclean.length > 0
		}
	}
}
</script>